export default "__VITE_ASSET__CgznMCTc__"